import { defineStore } from 'pinia'
import { ref } from 'vue'

const useDialogStore = defineStore('dialog', () => {
    const isVisible = ref(false)
    const message = ref('')
    const title = ref('')
    const confirmText = ref('확인')
    const cancelText = ref('취소')
    const showCancel = ref(false)
    const neutralText = ref('더보기')
    const showNeutral = ref(false)
    const promiseResolve = ref(null)
    const promiseReject = ref(null)

    const showDialog = ({
        msg,
        title: _title,
        confirm = '확인',
        neutral = '더보기',
        cancel = '취소',
        showCancelButton = false,
        showNeutralButton = false,
    }) => {
        message.value = msg
        title.value = _title
        confirmText.value = confirm
        cancelText.value = cancel
        showCancel.value = showCancelButton
        neutralText.value = neutral
        showNeutral.value = showNeutralButton
        isVisible.value = true

        return new Promise((resolve, reject) => {
            promiseResolve.value = resolve
            promiseReject.value = reject
        })
    }

    const hideDialog = () => {
        isVisible.value = false
        promiseResolve.value = null
        promiseReject.value = null
    }

    return {
        isVisible,
        message,
        title,
        confirmText,
        cancelText,
        showCancel,
        neutralText,
        showNeutral,
        promiseResolve,
        promiseReject,
        showDialog,
        hideDialog
    }
})

export default useDialogStore
